import React, { useContext } from "react";
import { ProductContext } from "../../../store";
import DetailSkeleton from "../../../components/Skeleton/DetailSkeleton";
import AuditHistorySection from "../../../components/AiVisibility/AuditHistorySection";

const AiVisibilityDashboard = () => {
	const { currentWebsiteId, websiteData, userLoader, websiteLoader } = useContext(ProductContext);

	const websiteURL =
		websiteData?.[currentWebsiteId]?.websiteURL ||
		websiteData?.[currentWebsiteId]?.websiteUrl ||
		"";

	if (userLoader || websiteLoader) {
		return <DetailSkeleton />;
	}

	return (
		<div className="contentBlock ai-visibility-dashboard">
			<h4 className="mb-1">AI Visibility</h4>
			<p className="text-muted mb-4">{websiteURL || "—"}</p>
			<AuditHistorySection />
		</div>
	);
};

export default AiVisibilityDashboard;
